import { useState } from "react";

const color = (e) => (e.in_blackout || e.impact === "High" ? "var(--red)" : "var(--amber)");

export const WeekAhead = ({ week }) => {
  const [all, setAll] = useState(false);
  const shown = all ? week : week.slice(0, 4);
  return (
    <section className="desk-card" data-testid="desk-week">
      <h2>This week · USD events</h2>
      {week.length === 0 ? <p className="text-base text-[color:var(--mute)]" data-testid="desk-week-empty">No upcoming USD events this week. Next week shows on Sunday.</p> : (
        <ul>
          {shown.map((e) => (
            <li key={e.key} className="flex gap-3 py-3 border-b border-[color:var(--line)] last:border-none" data-testid={`desk-week-${e.key}`}>
              <span className="w-1.5 rounded-full shrink-0" style={{ background: color(e) }} />
              <div className="flex-1 min-w-0">
                <div className="text-base font-semibold">{e.title}{e.simulated ? " (simulated)" : ""}</div>
                <div className="desk-mono text-sm text-[color:var(--mute)]">{e.gst} GST · {e.ist} IST</div>
              </div>
              <span className="text-sm font-semibold self-center" style={{ color: color(e) }}>{e.impact}</span>
            </li>
          ))}
        </ul>
      )}
      {week.length > 4 && <button className="desk-more" onClick={() => setAll(!all)} data-testid="desk-week-toggle">{all ? "Show less" : `Show all ${week.length}`}</button>}
    </section>
  );
};
